import { useState } from 'react';
import Select from 'react-select';

interface Props {
    onChange: (value: string) => void;
    value: number | string | undefined;
}

export default function OrderByTypeSelector({ onChange, value }: Props) {
    const [orderBy] = useState([
        { label: 'Nombre Comercial', value: 'CustomerId' },
        { label: 'Costo Total', value: 'TotalCost' },
        { label: 'Estado', value: 'ProjectStatusId' },
        { label: 'Fase', value: 'Phases' },
        { label: 'Avance', value: 'Percentage' },
    ]);

    return (
        <div className='mb-2'>
            <Select
                className='basic-single'
                classNamePrefix='select'
                isSearchable
                name='orderByTypes'
                options={orderBy}
                onChange={(selectedOrderBy) => {
                    onChange(selectedOrderBy!.value);
                }}
                value={
                    orderBy.find((color) => color.value === value) ?? {
                        label: `Ordenar por`,
                        value: 'Percentage',
                    }
                }
            />
        </div>
    );
}
